import { Box, Center, Flex, GridItem, Heading, Stack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { SUMMER_CAMP_ICON } from '@/client/services/summerCamp/constants'

import ShwGrid from '@/components/Layout/ShwGrid'

const WHAT_WILL_YOU_DO = [
  'Have fun learning new things—from coding to cooking—in virtual sessions hosted by Camp Counselors who are students like you!',
  'Make friends across the world in our global community of learners and tutors.',
]

const WHO_CAN_JOIN = ['Any student across the world, ages 13 and up!*']

export default function SummerCampAbout(): React.ReactElement {
  return (
    <ShwGrid alignItems="center" justifyItems="center" mt="40px" mb="24px">
      <GridItem colSpan={[12, 12, 12, 6]}>
        <Center>
          <Box>
            <Heading size="2xl" as="h2" mb="36px" color="fg">
              Join Schoolhouse Summer Camp to learn with and from other students across the
              world—100% free.
            </Heading>
            <Heading size="xl" as="h3" color="yellow.fg">
              In session July 1 to August 31.
            </Heading>
          </Box>
        </Center>
      </GridItem>
      <GridItem colSpan={[12, 12, 12, 6]} width="100%">
        <Box p={4}>
          <Stack spacing={4} mb={6}>
            <Text variant="eyebrow" color="yellow.fg">
              What Will You Do?
            </Text>
            {WHAT_WILL_YOU_DO.map(text => (
              <Flex key={text} alignItems="center">
                <Box minW="38px">
                  <FontAwesomeIcon icon={SUMMER_CAMP_ICON} color={chakraTokenToVar('yellow.fg')} />
                </Box>
                <Text color="fg">{text}</Text>
              </Flex>
            ))}
          </Stack>
          <Stack spacing={4}>
            <Text variant="eyebrow" color="yellow.fg">
              Who Can Join?
            </Text>
            {WHO_CAN_JOIN.map(text => (
              <Flex key={text} alignItems="center">
                <Box minW="38px">
                  <FontAwesomeIcon icon={SUMMER_CAMP_ICON} color={chakraTokenToVar('yellow.fg')} />
                </Box>
                <Text color="fg">{text}</Text>
              </Flex>
            ))}
          </Stack>
        </Box>
      </GridItem>
      <GridItem colSpan={12} width="100%" mt="24px">
        <Box textAlign="center">
          <Text color="gray.emphasized" fontSize="14px" fontWeight="light">
            *You must be at least 13 or older to join Schoolhouse. However, you may join Summer Camp
            late if you turn 13 within camp dates.
          </Text>
        </Box>
      </GridItem>
    </ShwGrid>
  )
}
